import { render } from "./setType.vue?vue&type=template&id=31a737fb&scoped=true"
import script from "./setType.vue?vue&type=script&lang=js"
export * from "./setType.vue?vue&type=script&lang=js"

import "./setType.vue?vue&type=style&index=0&id=31a737fb&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a737fb"]])

export default __exports__